import { render, staticRenderFns } from "./history.vue?vue&type=template&id=476eff5c&scoped=true"
import script from "./history.vue?vue&type=script&lang=js"
export * from "./history.vue?vue&type=script&lang=js"
import style0 from "./history.vue?vue&type=style&index=0&id=476eff5c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476eff5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476eff5c')) {
      api.createRecord('476eff5c', component.options)
    } else {
      api.reload('476eff5c', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=476eff5c&scoped=true", function () {
      api.rerender('476eff5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/home/history.vue"
export default component.exports